module.exports = __webpack_public_path__ + "Icono_AjustesMenu_126px.png";